import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { pageImages } from '../../data/siteData';
import PagePhotoViewer from '../../elements/PagePhotoViewer';

const page = {
  "slug": "manufacturers-industrial-plants",
  "title": "Manufacturers & Industrial Plants",
  "summary": "Heavy-duty baling and handling equipment for trimmings, by-products, and production waste.",
  "image": "equipment/horizontal-balers/horizontal-7.jpg",
  "highlights": [
    "Material-specific recommendations",
    "Baler loading and discharge planning",
    "Serviceable equipment design"
  ],
  "section": "Industries"
};

const navItems = [
  {
    "slug": "paper-mills",
    "title": "Paper Mills"
  },
  {
    "slug": "corrugated-container-manufacturers",
    "title": "Corrugated Container Manufacturers"
  },
  {
    "slug": "nonwoven-mills",
    "title": "Nonwoven Mills"
  },
  {
    "slug": "textile-mills-cotton-gins",
    "title": "Textile Mills & Cotton Gins"
  },
  {
    "slug": "distribution-centers",
    "title": "Distribution Centers"
  },
  {
    "slug": "manufacturers-industrial-plants",
    "title": "Manufacturers & Industrial Plants"
  },
  {
    "slug": "warehouses",
    "title": "Warehouses"
  },
  {
    "slug": "recycling-centers",
    "title": "Recycling Centers"
  }
];

const images = pageImages['manufacturers-industrial-plants'];


function ManufacturersIndustrialPlants() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          {navItems.map((item) => (
            <Link key={item.slug} className={item.slug === page.slug ? 'active' : ''} to={`/${item.slug}`}>{item.title}</Link>
          ))}
        </aside>
        <article className="article">
          <span className="eyebrow">{page.section}</span>
          <h2>{page.title}</h2>
          <div className="body-copy page-summary-copy">{page.summary}</div>
          {page.highlights?.length ? (
            <div className="page-summary-notes">
              {page.highlights.map((item) => <span key={item}>{item}</span>)}
            </div>
          ) : null}
          <PagePhotoViewer title={page.title} images={images} leadText={"C+M product applications include industrial trimmings and by-products across open-end automatic, open-end manual, and custom designed balers."} eyebrow="Application Photos" />
          <div className="content-stack">
            <section className="content-block">
              <h3>Industrial Plant By-Products</h3>
              <div className="body-copy">C+M product applications include industrial trimmings and by-products across open-end automatic, open-end manual, and custom designed balers.</div>
              <div className="body-copy">C+M can tailor <strong>infeed openings</strong>, hoppers, tramper systems, hydraulic packages, and discharge methods when a standard baler does not fit the <strong>material stream</strong>.</div>
              <div className="detail-points">
                <div className="detail-point">Industrial trimmings and by-products</div>
                <div className="detail-point">Custom hoppers and infeed systems</div>
                <div className="detail-point">Heavy-duty baler frames for demanding environments</div>
              </div>
            </section>
          </div>
          <Link className="button" to="/contact/request-quote">Request a Quote <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default ManufacturersIndustrialPlants;
